import { TimeInformationDatabaseData, CategoryDataStructure } from '../../../types/common';
import { ComponentState, IndependentTimeData, FeiertageTimeData } from '../components/TimeInformationInput/types';
import { INITIAL_INDEPENDENT_DATA, INITIAL_FEIERTAGE_DATA } from '../components/TimeInformationInput/constants';

/**
 * Convert component state to database format
 */
export const convertComponentStateToDatabase = (state: ComponentState): TimeInformationDatabaseData => {
  const categoryData: CategoryDataStructure = {};

  if (state.jahr.checked) {
    categoryData.jahr = {
      detaillierteBerechnung: state.jahr.data.detaillierteBerechnung,
      datenform: state.jahr.data.datenform,
      zeithorizontStart: state.jahr.data.zeithorizontStart,
      zeithorizontEnd: state.jahr.data.zeithorizontEnd,
      skalierung: state.jahr.data.skalierung,
      skalierungMin: state.jahr.data.skalierungMin,
      skalierungMax: state.jahr.data.skalierungMax
    };
  }

  if (state.monat.checked) {
    categoryData.monat = {
      detaillierteBerechnung: state.monat.data.detaillierteBerechnung,
      datenform: state.monat.data.datenform,
      zeithorizontStart: state.monat.data.zeithorizontStart,
      zeithorizontEnd: state.monat.data.zeithorizontEnd,
      skalierung: state.monat.data.skalierung,
      skalierungMin: state.monat.data.skalierungMin,
      skalierungMax: state.monat.data.skalierungMax
    };
  }

  if (state.woche.checked) {
    categoryData.woche = {
      detaillierteBerechnung: state.woche.data.detaillierteBerechnung,
      datenform: state.woche.data.datenform,
      zeithorizontStart: state.woche.data.zeithorizontStart,
      zeithorizontEnd: state.woche.data.zeithorizontEnd,
      skalierung: state.woche.data.skalierung,
      skalierungMin: state.woche.data.skalierungMin,
      skalierungMax: state.woche.data.skalierungMax
    };
  }

  if (state.tag.checked) {
    categoryData.tag = {
      detaillierteBerechnung: state.tag.data.detaillierteBerechnung,
      datenform: state.tag.data.datenform,
      zeithorizontStart: state.tag.data.zeithorizontStart,
      zeithorizontEnd: state.tag.data.zeithorizontEnd,
      skalierung: state.tag.data.skalierung,
      skalierungMin: state.tag.data.skalierungMin,
      skalierungMax: state.tag.data.skalierungMax
    };
  }

  if (state.feiertag.checked) {
    categoryData.feiertag = {
      detaillierteBerechnung: state.feiertag.data.detaillierteBerechnung,
      datenform: state.feiertag.data.datenform,
      zeithorizontStart: state.feiertag.data.zeithorizontStart,
      zeithorizontEnd: state.feiertag.data.zeithorizontEnd,
      skalierung: state.feiertag.data.skalierung,
      skalierungMin: state.feiertag.data.skalierungMin,
      skalierungMax: state.feiertag.data.skalierungMax,
      land: state.feiertag.data.land
    };
  }

  return {
    session_id: '',
    jahr: state.jahr.checked,
    monat: state.monat.checked,
    woche: state.woche.checked,
    tag: state.tag.checked,
    feiertag: state.feiertag.checked,
    zeitzone: state.zeitzone,
    category_data: categoryData
  };
};

/**
 * Convert database format to component state
 */
export const convertDatabaseToComponentState = (dbData: TimeInformationDatabaseData): ComponentState => {
  return {
    jahr: {
      checked: dbData.jahr,
      data: (dbData.category_data.jahr as IndependentTimeData) || { ...INITIAL_INDEPENDENT_DATA }
    },
    monat: {
      checked: dbData.monat,
      data: (dbData.category_data.monat as IndependentTimeData) || { ...INITIAL_INDEPENDENT_DATA }
    },
    woche: {
      checked: dbData.woche,
      data: (dbData.category_data.woche as IndependentTimeData) || { ...INITIAL_INDEPENDENT_DATA }
    },
    tag: {
      checked: dbData.tag,
      data: (dbData.category_data.tag as IndependentTimeData) || { ...INITIAL_INDEPENDENT_DATA }
    },
    feiertag: {
      checked: dbData.feiertag,
      data: (dbData.category_data.feiertag as FeiertageTimeData) || { ...INITIAL_FEIERTAGE_DATA }
    },
    zeitzone: dbData.zeitzone || 'UTC'
  };
};
